module.exports = StaffCard;